import _decorate from "@babel/runtime/helpers/esm/decorate";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "@babel/runtime/helpers/esm/get";
let _ = t => t,
  _t;
function _superPropGet(t, e, r, o) { var p = _get(_getPrototypeOf(1 & o ? t.prototype : t), e, r); return 2 & o ? function (t) { return p.apply(r, t); } : p; }
/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @ts-nocheck

import { html } from 'lit';
import { property } from 'lit/decorators.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import { formatVideoCaption, formatVideoDuration } from '@carbon/ibmdotcom-utilities/es/utilities/formatVideoCaption/formatVideoCaption.js';
import C4DCardFooter from "../card/card-footer.js";
import CTAMixin from "../../component-mixins/cta/cta-v1.js";
import VideoCTAMixin from "../../component-mixins/cta/video.js";
import { CTA_TYPE } from "./defs.js";
import styles from "././cta.css.js";
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';
const {
  prefix,
  stablePrefix: c4dPrefix
} = settings;

/**
 * Card CTA footer.
 *
 * @element c4d-card-footer
 * @csspart copy - The text content. Usage: `c4d-card-footer::part(copy)`
 */
let C4DCardCTAFooter = _decorate([customElement(`${c4dPrefix}-card-cta-footer`)], function (_initialize, _VideoCTAMixin) {
  class C4DCardCTAFooter extends _VideoCTAMixin {
    constructor(...args) {
      super(...args);
      _initialize(this);
    }
  }
  return {
    F: C4DCardCTAFooter,
    d: [{
      kind: "method",
      key: "_renderContent",
      value: function _renderContent() {
        const {
          ctaType,
          _hasCopy: hasCopy
        } = this;
        if (ctaType !== CTA_TYPE.VIDEO) {
          return _superPropGet(C4DCardCTAFooter, "_renderContent", this, 3)([]);
        }
        const {
          videoDuration,
          formatVideoCaption: formatVideoCaptionInEffect,
          formatVideoDuration: formatVideoDurationInEffect
        } = this;
        const caption = hasCopy ? undefined : formatVideoCaptionInEffect({
          duration: formatVideoDurationInEffect({
            duration: !videoDuration ? videoDuration : videoDuration * 1000
          })
        });
        return html(_t || (_t = _`
      <span class="${0}--card__cta__copy" part="copy"
        ><slot @slotchange="${0}"></slot>${0}</span
      >
    `), prefix, this._handleSlotChange, caption);
      }

      /**
       * The CTA type.
       */
    }, {
      kind: "field",
      decorators: [property({
        reflect: true,
        attribute: 'cta-type'
      })],
      key: "ctaType",
      value() {
        return CTA_TYPE.REGULAR;
      }
    }, {
      kind: "field",
      decorators: [property({
        attribute: false
      })],
      key: "formatVideoCaption",
      value() {
        return formatVideoCaption;
      }
    }, {
      kind: "field",
      decorators: [property({
        attribute: false
      })],
      key: "formatVideoDuration",
      value() {
        return formatVideoDuration;
      }
    }, {
      kind: "field",
      decorators: [property({
        type: Number,
        attribute: 'video-duration'
      })],
      key: "videoDuration",
      value: void 0
    }, {
      kind: "field",
      decorators: [property({
        attribute: 'video-description'
      })],
      key: "videoDescription",
      value: void 0
    }, {
      kind: "method",
      key: "connectedCallback",
      value:
      /**
       * The formatter for the video caption, composed with the video name and the video duration.
       * Should be changed upon the locale the UI is rendered with.
       */
      /**
       * The formatter for the video duration.
       * Should be changed upon the locale the UI is rendered with.
       */
      /**
       * The video duration.
       */
      /**
       * The video thumbnail URL.
       * Card CTA footer does not support video thumbnail, and this property should never be set.
       */
      /**
       * The video name.
       * This property should be set when a custom video title is needed.
       */
      /**
       * The video custom description.
       */
      function connectedCallback() {
        _superPropGet(C4DCardCTAFooter, "connectedCallback", this, 3)([]);
      }
    }, {
      kind: "get",
      static: true,
      key: "stableSelector",
      value: function () {
        return `${c4dPrefix}--card-cta-footer`;
      }
    }, {
      kind: "field",
      static: true,
      key: "styles",
      value() {
        return styles;
      }
    }]
  };
}, VideoCTAMixin(CTAMixin(C4DCardFooter)));
/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DCardCTAFooter;
//# sourceMappingURL=card-cta-footer.js.map
